import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "20",
      height: "3",
      rx: "1.5",
      fill: "white"
    }, null, -1),
    _createElementVNode("rect", {
      y: "17",
      width: "18",
      height: "3",
      rx: "1.5",
      fill: "white"
    }, null, -1),
    _createElementVNode("rect", {
      y: "8.5",
      width: "12",
      height: "3",
      rx: "1.5",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }